import { useEffect, useState } from 'react';
import { GamesService } from '../../../../../../shared/src/services/games.service';

export const useLowBalanceState = (balance) => {
    const [isLowAmount, setIsLowAmount] = useState(false);

    // detect low balance state
    useEffect(() => {
        if (balance && balance.Balance && GamesService.isLowBalance(balance.Balance)) {
            setIsLowAmount(true);
        }
    }, [balance]);

    // cancel low balance animation in 1min
    useEffect(() => {
        let timer = 0;
        const oneMinute = 1_000 * 60;

        if (isLowAmount) {
            timer = setTimeout(() => {
                setIsLowAmount(false);
            }, oneMinute);
        }

        return () => { clearTimeout(timer); };
    }, [isLowAmount]);

    return {
        isLowAmount,
    };
};
